<template>
    <div v-if="isLoading" class="loading-container">
        <img :src="require('@/assets/10.png')" alt="Logo" class="loading-logo" />
    </div>
    <div v-else>
        <div class="slide">
            <div class="bg-img">
                <div class="slide-content">
                    <div><h2 class="slide-header"> {{$t('message.ourOrders')}}</h2></div>
                <div>
                    <h5 class="slide-h5">{{$t('message.home')}}</h5>
                    <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider"></b-icon>
                    <h5 class="slide-h5"> {{$t('message.orders')}}</h5>
                </div>
            </div>
            </div>
        </div>
        <div v-if="Object.keys(this.order).length" class="container custom-container-orders mt-5">
            <b-button variant="link" class="back-btn" @click="$router.go(-1)"> <b-icon
                    :icon="isRTL ? 'chevron-right' : 'chevron-left'" class="icon-slider"></b-icon>{{ $t('message.back') }}</b-button>
            <b-tabs pills card>
                <b-tab :title="$t('message.orderDetails')" active>
                    <div>
                        <!-- Order Details content here -->
                        <b-row>
                            
                                <b-col cols="12">
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.reportNumber')}}</strong></p>
                                    <p> {{this.order.report_number || 'N/A'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.orderNumber')}}</strong></p>
                                    <p> {{this.order.id}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.orderTime')}}</strong></p>
                                    <p>{{this.order.created_date}}</p>
                                </div>
                                <div v-if="order.due_date && order.due_date !== null && order.due_date !== ''" class="equipments-header">
                                    <p><strong>{{$t('message.expectedResolutionDate')}}</strong></p>
                                    <p>{{order.due_date}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.createdBy')}}</strong></p>
                                    <p> {{this.order.adminName}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.clientName')}}</strong></p>
                                    <p> {{this.order.customer_name}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.phoneNumber')}}</strong></p>
                                    <p> {{this.order.customer_phone}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.address')}}</strong></p>
                                    <p style="margin-left: 45px;"><a :href="googleMapsLink(this.order.customerMapUrl)" target="_blank">{{ this.order.customerMapUrl }}</a></p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.services')}}</strong></p>
                                    <p> {{this.order.serviceName}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.equipmentName')}}</strong></p>
                                    <p> {{this.order.equpment_name || 'N/A'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.problemDetails')}}</strong></p>
                                    <p> {{this.order.problem_desc || 'N/A'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.Technician')}}</strong></p>
                                    <p> {{this.order.technicalLeaderName}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.distanceUsed')}}</strong></p>
                                    <p> {{this.order.distance_km || '0'}} km</p>
                                </div>
                            </b-col>
                            
                            
                        </b-row>
                    </div>
                    <hr style="background-color: #C0DBFF;height: 2px;">
                    <div>
                        <b-row>
                            <b-col cols="12">
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.status')}}</strong></p>
                                    <p :style="{ color: statusColor, fontWeight: 'bold' }">{{statusName }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.outOfScope')}}</strong></p>
                                    <p>{{getBooleanValue(this.order.out_of_scope) }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.needProject')}}</strong></p>
                                    <p>{{getBooleanValue(this.order.need_project) }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.needApproval')}}</strong></p>
                                    <p>{{ needApprovalDisplay }}</p>
                                </div>
                                
                                

                                <div v-if="order.order_status == 5 && order.need_approval == 1" class="mt-4 approval-section">
                                    <div class="approval-box">
                                        <div class="comment-box">
                                            <div class="comment-header">
                                                <b-icon icon="chat-left-text-fill" class="comment-icon"></b-icon>
                                                <strong>{{ isRTL ? 'تعليق الموافقة' : 'Approval Comment' }}</strong>
                                            </div>
                                            <div class="comment-content">
                                                <p>{{ order.comment_need_approval || (isRTL ? 'لا يوجد تعليق' : 'No comment provided') }}</p>
                                            </div>
                                        </div>
                                        
                                        <div class="approval-actions">
                                            <button class="btn-approve" @click="approveOrder">
                                                <b-icon icon="check-circle-fill" class="btn-icon"></b-icon>
                                                {{ isRTL ? 'موافق عليه' : 'Approve' }}
                                            </button>

                                            <button class="btn-reject" @click="rejectOrder">
                                                <b-icon icon="x-circle-fill" class="btn-icon"></b-icon>
                                                {{ isRTL ? 'رفض' : 'Reject' }}
                                            </button>
                                        </div>
                                    </div>
                                </div>


                                <div class="equipments-header">
                                    <p><strong>{{$t('message.solvedRemotely')}}</strong></p>
                                    <p>{{getBooleanValue(this.order.solved_remotly) }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.repairOnSite')}}</strong></p>
                                    <p>{{getBooleanValue(this.order.on_site_repair) }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.maintenanceTeamSetup')}}</strong></p>
                                    <p>{{maintenanceTeamSetupStatus }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.maintenanceTechnicianAdded')}}</strong></p>
                                    <p>{{maintenanceTechnicianStatus }}</p>
                                </div>
                            </b-col>
                            
                        </b-row>
                    </div>
                </b-tab>

                <b-tab :title="$t('message.equipments')">
                    <div class="mb-5">
                        <b-row>
                            <b-col cols="12">
                                <div class="equipments-header">
                                    <p><strong>{{ $t('message.equipmentRepalced') }}</strong></p>
                                    <p> {{equipmentReplacedText }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{ $t('message.equipmentRepalcedAvailable') }}</strong></p>
                                    <p> {{equipmentReplacedText }}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{ $t('message.errorType') }}</strong></p>
                                    <p>{{this.order.error_type || 'N/A'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{ $t('message.activityDomains') }}</strong></p>
                                    <p> {{this.order.activity_domain || 'N/A'}}</p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="mb-5">
                        <b-table
                        :items="equipmentTableData"
                        :fields="fields"
                        responsive="sm"
                        hover 
                        striped 
                        bordered
                        >

                        <template #thead-top="data">
                            <b-tr>
                            <b-th style="width: 20%;"colspan="1"><span class="sr-only">Status</span></b-th>
                            <b-th class="repalced-equipment" style="width: 40%;">{{ isRTL ? 'المعدات المستبدلة' : 'Replaced Equipment' }}</b-th>
                            <b-th class="spare-parts"style="width: 40%;" colspan="3">{{ isRTL ? 'قطع الغيار' : 'Spare Parts' }}</b-th>
                            </b-tr>
                        </template>
                        </b-table>
                    </div>
                    <div class="mb-5">
                        <b-row>
                            <b-col cols="12">
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.subEquipmentReplaced')}}</strong></p>
                                    <p> {{getBooleanValue(this.order.sub_equipment_replaced)}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{ $t('message.subEquipmentReplacedAvailable') }}</strong></p>
                                    <p>{{getBooleanValue(this.order.sub_equipment_replaced)}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.errorType')}}</strong></p>
                                    <p>{{this.order.error_type || 'N/A'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.activityDomains')}}</strong></p>
                                    <p> {{this.order.activity_domain || 'N/A'}}</p>
                                </div>
                            </b-col>
                        </b-row>
                    </div>


                    <div class="mb-5">
                        <b-table
                        :items="subEquipmentTableData"
                        :fields="fields"
                        responsive="sm"
                        hover 
                        striped 
                        bordered
                        >

                        <template #thead-top="data">
                            <b-tr>
                            <b-th style="width: 20%;"colspan="1"><span class="sr-only">Status</span></b-th>
                            <b-th class="repalced-equipment" style="width: 40%;">{{ isRTL ? 'المعدات الفرعية المستبدلة' : 'Replaced Sub Equipment' }}</b-th>
                            <b-th class="spare-parts"style="width: 40%;" colspan="3">{{ isRTL ? 'قطع الغيار' : 'Spare Parts' }}</b-th>
                            </b-tr>
                        </template>
                        </b-table>
                    </div>
                </b-tab>

                <b-tab title="The Time">
                    <div>
                        <div class="">
                            <b-row>
                                <b-col cols="12">
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.siteArrivalDate')}}</strong></p>
                                        <p> {{this.order.site_arrival_date}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.siteArrivalTime')}}</strong></p>
                                        <p>{{this.order.site_arrival_time}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.repairStartDate')}}</strong></p>
                                        <p>{{this.order.repair_start_date || 'N/A'}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.repairStartTime')}}</strong></p>
                                        <p>{{this.order.repair_start_time || 'N/A'}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.repairEndDate')}}</strong></p>
                                        <p> {{this.order.repair_end_date || 'N/A'}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.repairEndTime')}}</strong></p>
                                        <p> {{this.order.repair_end_time}}</p>
                                    </div>
                                    <!-- <div class="equipments-header">
                                        <p><strong>{{$t('message.startLocationLatitude')}}</strong></p>
                                        <p> {{this.order.start_latitude}}</p>
                                    </div> -->
                                    <!-- <div class="equipments-header">
                                        <p><strong>{{$t('message.startLocationLongitude')}}</strong></p>
                                        <p> {{this.order.start_longitude}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.endLocationLatitude')}}</strong></p>
                                        <p> {{this.order.end_latitude}}</p>
                                    </div> -->
                                    <!-- <div class="equipments-header">
                                        <p><strong>{{$t('message.endLocationLongitude')}}</strong></p>
                                        <p> {{this.order.end_longitude || 'N/A'}}</p>
                                    </div> -->
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.startLocationAddress')}}</strong></p>
                                        <p><a :href="googleMapsLink(this.order.customerMapUrl)" target="_blank" v-if="this.order.customerMapUrl">{{ this.order.customerMapUrl }}</a><span v-else>N/A</span></p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.endLocationAddress')}}</strong></p>
                                        <p><a :href="googleMapsLink(this.order.customerMapUrl)" target="_blank" v-if="this.order.customerMapUrl">{{ this.order.customerMapUrl }}</a><span v-else>N/A</span></p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.siteDepartureDate')}}</strong></p>
                                        <p> {{this.order.site_departure_date || 'N/A'}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{$t('message.siteDepartureTime')}}</strong></p>
                                        <p> {{this.order.site_departure_time}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{ $t('message.ttf') }}</strong></p>
                                        <p> {{this.order.ttf}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{ $t('message.tta') }}</strong></p>
                                        <p> {{this.order.tta}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{ $t('message.ttr') }}</strong></p>
                                        <p> {{this.order.ttr || 'N/A'}}</p>
                                    </div>
                                    <div class="equipments-header">
                                        <p><strong>{{ $t('message.ttd') }}</strong></p>
                                        <p> {{this.order.ttd || 'N/A'}}</p>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>

                    </div>
                </b-tab>

                <b-tab title="The Cost">
                    <div>
                        <div>
                        <b-row>
                            <b-col cols="12">
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.transportedBy')}}</strong></p>
                                    <p>{{this.order.transportationName || 'N/A'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.transportationCost')}}</strong></p>
                                    <p> {{this.order.transportation_cost || '0'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.tollGateCost')}}</strong></p>
                                    <p> {{this.order.toll_gate_cost || '0'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.additionalNotes')}}</strong></p>
                                    <p> {{this.order.additional_note || 'N/A'}}</p>
                                </div>
                                <div class="equipments-header">
                                    <p><strong>{{$t('message.attachments')}}</strong></p>
                                </div>

                                <div class="uploaded-files">
                                    <div v-for="(file) in Files" :key="file.id"
                                        class="file-item col-md-3">
                                        <div style="text-align: center;">
                                            <img :src="file.attachment_url" class="uploaded-image" @click="openInNewTab(file.attachment_url,'image')" />
                                            <!-- <div class="limit-name">{{ file.name }}</div> -->
                                        </div>
                                        <div>
                                            <b-icon class="download-icon" @click="downloadFile(file.url, file.file_name)"
                                                icon="download" aria-hidden="true"></b-icon>
                                        </div>
                                        
                                        
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
        <div v-else>
            <div class="text-center p-4" style="width: 100%;">
                <img :src= "require('../assets/not-found.svg')" alt="404 Photo" style="width:500px;">
                <p class="mb-0 filter-result"> {{ $t('message.noMatchingResults') }} "{{ id }}".</p>
            </div>
        </div>
    </div>
</template>

<script>
import axiosInstance from '../axios-config';

export default {
    name: 'ShowDetails',
    props: ['id'], // التأكد من أن الخاصية id تم تمريرها بشكل صحيح
    data() {
        return {
            order:{
                order_status: null,
                equipment_replaced: null,
                need_approval: null,
            },
            items: [
                { Status: 'Family Code', Used: 1,   New: 542 },
                { Status: 'Equip Family', Used: 2,  New: 'Fuel Tank & Pipework' },
                { Status: 'Type Code', Used: 3,  New: 'Fuel Tank & Pipework' },
                { Status: 'Equip Type', Used: 4, New: 'Fuel Tank & Pipework' },
                { Status: 'Equip Serial', Used: 5,  New: 'Fuel Tank & Pipework' },
                { Status: 'Equip Model', Used: 5,  New: 'Fuel Tank' },
                { Status: 'Equip Manufacturer', Used: 5,  New: 'Fuel Tank' },
                { Status: 'Cost', Used: 5,  New: 'Fuel Tank' },
            ],
            fields: [
                'Status',
                { key: 'Used', label: 'Used' },
                { key: 'New', label: 'New' }
            ],
            Files:[],
            downloadedFiles: new Set(), // تخزين الملفات التي تم تنزيلها
            isLoading: true,
            equipmentsInOrder: [], // المعدات في الطلب
        };

    },

    computed: {
        isRTL() {
            return this.$i18n.locale === 'ar';
        },
        statusName() {
            // Handle status 5 with needApproval (same logic as OrdersView)
            if (this.order.order_status == 5 || this.order.order_status == "5") {
                // Convert to string for comparison
                const needApproval = String(this.order.need_approval);
                if (needApproval == "1") {
                    return 'Need Approval';
                } else if (needApproval == "3") {
                    return 'Approved';
                } else if (needApproval == "4") {
                    return 'Approval Refused';
                }
            }
            
            // Handle other statuses
            const statusMap = {
                0: 'Pending',
                1: 'Started',
                2: 'Started',
                3: 'Completed',
                4: 'Decline',
                6: 'In Process',
                '0': 'Pending',
                '1': 'Started',
                '2': 'Started',
                '3': 'Completed',
                '4': 'Decline',
                '6': 'In Process',
            };
            return statusMap[this.order.order_status] || 'Unknown Status';
        },
        
        statusColor() {
            // Same logic as getStatusColor in OrdersView
            if (this.order.order_status == 5 || this.order.order_status == "5") {
                const needApproval = String(this.order.need_approval);
                if (needApproval == "1") {
                    return '#FF5722'; // Orange
                } else if (needApproval == "3" || needApproval == "4") {
                    return '#FEC200'; // Yellow
                }
            }
            
            const colorMap = {
                0: '#777D85',
                1: '#FF0000',
                2: '#FF0000',
                3: '#5BC236',
                4: '#FF0000',
                6: '#FEC200',
                '0': '#777D85',
                '1': '#FF0000',
                '2': '#FF0000',
                '3': '#5BC236',
                '4': '#FF0000',
                '6': '#FEC200',
            };
            return colorMap[this.order.order_status] || '#777D85';
        },

        needApprovalDisplay() {
            const orderStatus = String(this.order.order_status);
            const needApproval = String(this.order.need_approval);

            // لو Pending (0) أو Started (1, 2) → غير متاح
            if (orderStatus == "0" || orderStatus == "1" || orderStatus == "2") {
                return this.isRTL ? 'غير متاح' : 'Not Available';
            }

            // لو Completed (3)
            if (orderStatus == "3") {
                if (needApproval == "3") {
                    return this.isRTL ? 'موافق عليه' : 'Approved';
                } else if (needApproval == "0") {
                    return this.isRTL ? 'لا' : 'No';
                }
            }

            // لو order_status = 5 (Need Approval / Approved / Approval Refused)
            if (orderStatus == "5") {
                if (needApproval == "1") {
                    return this.isRTL ? 'بحاجة للموافقة' : 'Need Approval';
                } else if (needApproval == "3") {
                    return this.isRTL ? 'موافق عليه' : 'Approved';
                } else if (needApproval == "4") {
                    return this.isRTL ? 'رفض' : 'Refused';
                }
            }

            // لو Decline (4) أو In Process (6)
            if (orderStatus == "4" || orderStatus == "6") {
                return this.isRTL ? 'غير متاح' : 'Not Available';
            }

            // Default
            return this.isRTL ? 'لا يوجد' : 'N/A';
        },
        equipmentReplacedText() {
            const statusMap = {
                0: 'No',
                1: 'Yes',
                '-1': 'Not Available',
            };
            return statusMap[this.order.equipment_replaced] || 'Unknown';
        },
        maintenanceTeamSetupStatus() {
            if (!this.order.technicians || !Array.isArray(this.order.technicians)) {
                return this.isRTL ? 'لا يوجد' : 'N/A';
            }
            return this.order.technicians.some(t => t && t.name) 
                ? (this.isRTL ? 'نعم' : 'Yes') 
                : (this.isRTL ? 'لا' : 'No');
        },
        maintenanceTechnicianStatus() {
            if (!this.order.technicians || !Array.isArray(this.order.technicians)) {
                return this.isRTL ? 'لا يوجد' : 'N/A';
            }
            return this.order.technicians.some(t => t && t.name) 
                ? (this.isRTL ? 'تم الإضافة' : 'Added') 
                : (this.isRTL ? 'لم يتم الإضافة' : 'Not Added');
        },
        equipmentTableData() {
            // بناء البيانات من الـ equipmentsInOrder
            if (!this.equipmentsInOrder || this.equipmentsInOrder.length === 0) {
                return [];
            }
            
            const equipment = this.equipmentsInOrder[0]; // أول معدة
            const data = [
                { 
                    Status: 'Family Code', 
                    Used: equipment.equipmentFamilyCode || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Family', 
                    Used: equipment.equipmentFamilyName || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Type Code', 
                    Used: equipment.equipmentTypeCode || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Type', 
                    Used: equipment.equipment_type || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Serial', 
                    Used: equipment.serial_number || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Model', 
                    Used: equipment.equipment_model || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Manufacturer', 
                    Used: equipment.equipment_manufactor || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Cost', 
                    Used: equipment.cost || '-', 
                    New: '-' 
                }
            ];
            return data;
        },
        subEquipmentTableData() {
            // بناء البيانات للمعدات الفرعية
            if (!this.equipmentsInOrder || this.equipmentsInOrder.length < 2) {
                return [];
            }
            
            const subEquipment = this.equipmentsInOrder[1]; // ثاني معدة
            const data = [
                { 
                    Status: 'Family Code', 
                    Used: subEquipment.equipmentFamilyCode || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Family', 
                    Used: subEquipment.equipmentFamilyName || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Type Code', 
                    Used: subEquipment.equipmentTypeCode || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Type', 
                    Used: subEquipment.equipment_type || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Serial', 
                    Used: subEquipment.serial_number || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Model', 
                    Used: subEquipment.equipment_model || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Equip Manufacturer', 
                    Used: subEquipment.equipment_manufactor || '-', 
                    New: '-' 
                },
                { 
                    Status: 'Cost', 
                    Used: subEquipment.cost || '-', 
                    New: '-' 
                }
            ];
            return data;
        },
    },
    created() {
        this.fetchData();
        this.fetchFiles();
        this.fetchEquipments();
    },
    methods: {
        googleMapsLink(location) {
            const encodedLocation = encodeURIComponent(location);
            return `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
        },
        getBooleanValue(value) {
            if (value === "0" || value === 0) return this.isRTL ? 'لا' : 'No';
            if (value === "1" || value === 1) return this.isRTL ? 'نعم' : 'Yes';
            if (value === "-1" || value === -1) return this.isRTL ? 'غير متوفر' : 'Not Available';
            if (value === null || value === undefined || value === '') return this.isRTL ? 'لا يوجد' : 'N/A';
            return this.isRTL ? 'غير معروف' : 'Unknown';
        },

        async fetchData() {
            try {
                const formData = new FormData();
                formData.append('order_id', this.id);
                const response = await axiosInstance.post('company/select_order_by_id.php', formData);

                console.log(response.data);
                if (response.data.status === "true") {
                    this.order = response.data.output;
                    console.log('order = ', this.order);
                    this.isLoading = false;
                }
            } catch (error) {
                console.error('Error logging in:', error)
                this.$izitoast.error({
                    title: 'Error',
                    message: 'An error occurred while trying to get data',
                    position: 'bottomLeft',
                    timeout: 5000,
                });
                this.isLoading = false;
            }
        },
        async approveOrder() {
    await this.updateApprovalStatus(3); // 3 = Approved
},

async rejectOrder() {
    await this.updateApprovalStatus(4); // 4 = Rejected
},

async updateApprovalStatus(actionValue) {
    try {
        const formData = new FormData();
        
        formData.append('order_id', this.order.id);
        formData.append('out_of_scope', this.order.out_of_scope);
        formData.append('need_project', this.order.need_project);
        formData.append('need_approval', actionValue); // 👈 هنا بنغير بس
        formData.append('solved_remotly', this.order.solved_remotly);
        formData.append('on_site_repair', this.order.on_site_repair);
        formData.append('site_arrival_date', this.order.site_arrival_date);
        formData.append('site_arrival_time', this.order.site_arrival_time);
        formData.append('site_departure_date', this.order.site_departure_date);
        formData.append('site_departure_time', this.order.site_departure_time);
        formData.append('repair_start_date', this.order.repair_start_date);
        formData.append('repair_start_time', this.order.repair_start_time);
        formData.append('repair_end_date', this.order.repair_end_date);
        formData.append('repair_end_time', this.order.repair_end_time);
        formData.append('start_latitude', this.order.start_latitude);
        formData.append('start_longitude', this.order.start_longitude);
        formData.append('end_latitude', this.order.end_latitude);
        formData.append('end_longitude', this.order.end_longitude);
        formData.append('order_status', this.order.order_status);
        formData.append('comment_need_approval', this.order.comment_need_approval ?? '');

        const res = await axiosInstance.post('technical/update_order_details.php', formData);

        if (res.data.status == "true") {
            
            this.$izitoast.success({
                    title: 'success',
                    message: this.isRTL ? 'تم تحديث الحالة بنجاح ✅' : 'Status updated successfully ✅',
                    position: 'bottomLeft',
                    timeout: 5000,
                });
            this.fetchData(); // refresh
        } else {
            throw new Error();
        }

    } catch (e) {
        this.$izitoast.error({
            title: 'Error',
            message: this.isRTL ? 'حدث خطأ ⚠️' : 'Error occurred ⚠️',
            position: 'bottomLeft',
            timeout: 5000,
        });
    }
},

        async fetchFiles() {
            try {
                const formData = new FormData();
                formData.append('order_id', this.id);
                const response = await axiosInstance.post('technical/select_order_attachments.php', formData);

                console.log(response.data);
                if (response.data.status === "true") {
                    this.Files = response.data.output;
                    console.log('order = ', this.order);
                }
            } catch (error) {
                console.error('Error logging in:', error)
                this.$bvToast.toast('An error occurred while trying to get files', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-left', // Position of the toast
                    // autoHideDelay: 1000,
                });
            }
        },
        openInNewTab(url, type) {
            console.log('type:',type);
            console.log('url:',url);
            
            window.open(url, '_blank');

        },
        downloadFile(url, fileId) {
            if (this.downloadedFiles.has(fileId)) {
                // عرض رسالة تفيد بأن الملف تم تنزيله مسبقًا
                this.$izitoast.warning({
                    title: 'Warning',
                    message: 'You have already downloaded this file.',
                    position: 'bottomLeft',
                    timeout: 5000,
                });
                return; // منع التنزيل
            }

            // جلب الملف
            fetch(url)
            .then(response => response.blob()) // تحويل الاستجابة إلى Blob
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob); // إنشاء رابط URL مؤقت للملف
                    link.download = `file_${fileId}`; // تعيين اسم افتراضي للملف
                    document.body.appendChild(link); // إضافة الرابط إلى DOM
                    link.click(); // النقر على الرابط لتنزيل الملف
                    document.body.removeChild(link); // إزالة الرابط بعد التنزيل

                    // إضافة الملف إلى مجموعة الملفات التي تم تنزيلها
                    this.downloadedFiles.add(fileId);

                    // عرض رسالة النجاح
                    this.$izitoast.success({
                        title: 'Success',
                        message: 'File downloaded successfully.',
                        position: 'bottomLeft',
                        timeout: 5000,
                    });
                })
                .catch(error => {
                    // عرض رسالة الخطأ
                    this.$izitoast.error({
                        title: 'Error',
                        message: 'An error occurred while trying to download the file.',
                        position: 'bottomLeft',
                        timeout: 5000,
                    });
                    console.error('Error downloading the file:', error);
                });
        },
        showDetails(itemId){
            console.log(111111111);
            // this.$router.push('show-details/' + itemId);
            this.$router.push(`/orders/${itemId}/details`);
            // /orders/:id/details
        },
        async fetchEquipments() {
            try {
                const formData = new FormData();
                formData.append('order_id', this.id);
                const response = await axiosInstance.post('company/select_equipments_in_order.php', formData);

                console.log('Equipments Response:', response.data);
                if (response.data.status === "true") {
                    this.equipmentsInOrder = response.data.output;
                    console.log('equipments = ', this.equipmentsInOrder);
                }
            } catch (error) {
                console.error('Error fetching equipments:', error);
                this.$izitoast.error({
                    title: 'Error',
                    message: 'An error occurred while trying to get equipments',
                    position: 'bottomLeft',
                    timeout: 5000,
                });
            }
        }
    }

};
</script>

<style scoped>
.custom-container-orders {
    /* Custom styles for the container */
}

.back-btn {
    color: #003A6E;
    font-family: 'Somar-Bold';
    font-size: 28px;
    display: flex;
    align-items: center;
}

.back-btn:hover {
    text-decoration: none;
    color: #003A6E;
}

.icon-slider {
    font-size: 15px !important;
    color: #FFD448 !important;
    margin-top: 0px !important;
}

.detais-header p strong {
    color: #2B5FA8;
    font-family: 'Somar-Bold';
    font-size: 25px;
}
.equipments-header p strong {
    color: #2B5FA8;
    font-family: 'Somar-Bold';
    font-size: 25px;
}

.detais-response p {
    color: #7F98BB;
    font-family: 'Somar-Medium';
    font-size: 25px;
}
.equipments-header p {
    color: #7F98BB;
    font-family: 'Somar-Medium';
    font-size: 25px;
}
p{
    /* margin-bottom: 5px; */
}
.equipments-header{
    display: flex;
    justify-content: space-between;
}
.repalced-equipment , .spare-parts{
    color: #fff;
    font-family: 'Somar-Bold';
    font-size: 22px;
    text-align: center
}
.repalced-equipment{
    background-color:#5B9BF5;
}
.spare-parts{
    background-color:#2B5FA8;
}
.uploaded-files {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  justify-content: left;
}


.file-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #dee2e6;
  padding: 2px;
  border-radius: 5px;
  background-color: #f8f9fa;
  /* width: 22%; */
  justify-content: center;
  min-height: 165px;
}

/* .limit-name {
  text-align: center;
  width: 150px;
  overflow: hidden;
} */

.uploaded-image {
  width: 100px;
  /* width: -webkit-fill-available; */
  height: 90px;
  object-fit: cover;
  border-radius: 5px;
  /* margin-bottom: 5px; */
}
.uploaded-image:hover{
    cursor: pointer;
}

.file-item progress {
  width: 100%;
  margin: 5px 0;
  height: 5px;
  border-radius: 50px;
}

.file-item button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  padding: initial;
}
.download-icon {
    position: absolute;
    left: 11px;
    top: 9px;
    color: #FF0000;
    font-size: 20px;
    cursor: pointer;
}
/* Approval Section Container */
.approval-section {
  width: 100%;
  margin: 30px 0;
}

.approval-box {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 2px solid rgba(255, 165, 0, 0.3);
}

/* Comment Box Styles */
.comment-box {
  background: #ffffff;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left: 5px solid #FF9800;
}

.comment-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  color: #FF9800;
  font-size: 18px;
  font-family: 'Somar-Bold';
}

.comment-icon {
  font-size: 22px;
}

.comment-content {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
  margin-top: 10px;
}

.comment-content p {
  margin: 0;
  color: #495057;
  font-size: 16px;
  line-height: 1.6;
  font-family: 'Somar-Regular';
}

/* Approval Actions Container */
.approval-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

/* Approve Button */
.btn-approve {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  padding: 14px 35px;
  color: white;
  font-size: 18px;
  border-radius: 50px;
  cursor: pointer;
  font-family: 'Somar-Bold';
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 160px;
  justify-content: center;
}

.btn-approve:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(40, 167, 69, 0.6);
  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);
}

.btn-approve:active {
  transform: translateY(-1px);
}

/* Reject Button */
.btn-reject {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  border: none;
  padding: 14px 35px;
  color: white;
  font-size: 18px;
  border-radius: 50px;
  cursor: pointer;
  font-family: 'Somar-Bold';
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 160px;
  justify-content: center;
}

.btn-reject:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(220, 53, 69, 0.6);
  background: linear-gradient(135deg, #c82333 0%, #dc3545 100%);
}

.btn-reject:active {
  transform: translateY(-1px);
}

/* Button Icon */
.btn-icon {
  font-size: 20px;
}

</style>

